import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useChangeFirstLoginPassword, useLogin } from '../api/queries';
import type { LoginForm } from '../model/credentials';

const REMEMBER_EMAIL_KEY = 'movofleet_login_email';

function readRememberedEmail(): string {
  try {
    return localStorage.getItem(REMEMBER_EMAIL_KEY) || '';
  } catch {
    // Storage bloccato dal browser: il modulo parte vuoto.
    return '';
  }
}

function rememberEmail(email: string) {
  try {
    if (email) localStorage.setItem(REMEMBER_EMAIL_KEY, email);
    else localStorage.removeItem(REMEMBER_EMAIL_KEY);
  } catch {
    // Storage bloccato dal browser: l'accesso continua, l'email non resta.
  }
}

/** Il login: email ricordata, accesso, e il cambio password quando il server lo chiede. */
export function useLoginScreen() {
  const navigate = useNavigate();
  const [rememberedEmail] = useState(readRememberedEmail);
  const [mustChangePassword, setMustChangePassword] = useState(false);
  const login = useLogin();
  const changePassword = useChangeFirstLoginPassword();

  const submit = ({ email, password, rememberMe }: LoginForm) => {
    const trimmed = email.trim();
    rememberEmail(rememberMe ? trimmed : '');
    login.mutate(
      { email: trimmed, password },
      {
        onSuccess: (session) => {
          if (session.mustChangePassword) setMustChangePassword(true);
          else navigate('/dashboard');
        },
      }
    );
  };

  const changeFirstLoginPassword = (newPassword: string) =>
    changePassword.mutate(newPassword, { onSuccess: () => navigate('/dashboard') });

  return {
    defaultEmail: rememberedEmail,
    defaultRememberMe: Boolean(rememberedEmail),
    submitting: login.isPending,
    error: login.error?.message,
    submit,
    firstLoginDialog: mustChangePassword
      ? {
          submitting: changePassword.isPending,
          error: changePassword.error?.message,
          onSubmit: changeFirstLoginPassword,
        }
      : null,
  };
}
